export enum UserRoleEnum {
    USER = 'user',
    ADMIN = 'admin',
    WELLPLATE_OVERPACK = 'wellplateOverpack',
    UNKNOWN = 'unknown',
}
